export * from "@workspace/gamja-platform/components/FeatureLockedModal";
export { default } from "@workspace/gamja-platform/components/FeatureLockedModal";
